import { render, staticRenderFns } from "./PoyDetailsDocs.vue?vue&type=template&id=e25f6b08&"
import script from "./PoyDetailsDocs.vue?vue&type=script&lang=js&"
export * from "./PoyDetailsDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports